import getLeftCharmsContainerWidth from "./getLeftCharmsContainerWidth";

/**
 * Gets the style for the left charms container.
 * @param searchAlignmentWidth - The width of the search alignment container.
 * @param leadingControlsWidth - The rendered width of controls before the alignment container.
 * @returns The style for the left charms container.
 */
export default function getLeftCharmsContainerStyle(searchAlignmentWidth?: number, leadingControlsWidth?: number): React.CSSProperties | undefined {
    return searchAlignmentWidth
        ? ({
            "--header-left-charms-width": `${getLeftCharmsContainerWidth(searchAlignmentWidth, leadingControlsWidth)}px`,
        } as React.CSSProperties)
        : undefined;
}
